// Also the people_add_tab values on people_add_tab_selected, so renaming one splits its Amplitude series.
export const ADD_PEOPLE_TABS = ["directory", "calendar", "manual", "bulk_upload"] as const;

export type AddPeopleTab = (typeof ADD_PEOPLE_TABS)[number];

export const isAddPeopleTab = (value: unknown): value is AddPeopleTab => ADD_PEOPLE_TABS.includes(value as AddPeopleTab);
